module.exports = __webpack_public_path__ + "f0295f472e0f726d9c5ffd078e702bed.pdf";